<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="店铺ID">
        <el-input
          v-model="query.shop_id"
          placeholder="店铺ID"
          clearable
          style="width: 140px"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择" clearable>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="已同意(处理中)" :value="1"></el-option>
          <el-option label="已拒绝" :value="2"></el-option>
          <el-option label="退款成功" :value="3"></el-option>
          <el-option label="退款失败" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="query.createTime"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #status="{ row }">
        <el-tag size="small" type="info" v-if="row.status === 0">待审核</el-tag>
        <el-tag size="small" v-if="row.status === 1">处理中</el-tag>
        <el-tag size="small" type="danger" v-if="row.status === 2">已拒绝</el-tag>
        <el-tag size="small" type="success" v-if="row.status === 3"
          >退款成功</el-tag
        >
        <el-tag size="small" type="warning" v-if="row.status === 4"
          >退款失败</el-tag
        >
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="primary" @click="openInfo(row)"
          >详情</el-button
        >
        <el-button
          size="small"
          type="success"
          v-if="row.status === 0 || row.status === 4"
          :loading="row.id === approvingId"
          @click="approve(row)"
          >{{ row.status === 4 ? "重试退款" : "同意" }}</el-button
        >
        <el-button
          size="small"
          type="danger"
          v-if="row.status === 0 || row.status === 4"
          @click="openReject(row)"
          >拒绝</el-button
        >
      </template>
    </auto-table>

    <!-- 申请详情 -->
    <el-dialog title="退押申请详情" :visible.sync="infoShow" width="50%">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="申请单号">{{
          curInfo.id
        }}</el-descriptions-item>
        <el-descriptions-item label="店铺">{{
          curInfo.shop_name || curInfo.shop_id
        }}</el-descriptions-item>
        <el-descriptions-item label="申请人手机号">{{
          curInfo.user_mobile || curInfo.user_id
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额(元)">{{
          curInfo.amount
        }}</el-descriptions-item>
        <el-descriptions-item label="申请原因" :span="2">{{
          curInfo.reason
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="small" type="info" v-if="curInfo.status === 0"
            >待审核</el-tag
          >
          <el-tag size="small" v-if="curInfo.status === 1">处理中</el-tag>
          <el-tag size="small" type="danger" v-if="curInfo.status === 2"
            >已拒绝</el-tag
          >
          <el-tag size="small" type="success" v-if="curInfo.status === 3"
            >退款成功</el-tag
          >
          <el-tag size="small" type="warning" v-if="curInfo.status === 4"
            >退款失败</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="退款单号">{{
          curInfo.refund_id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{
          curInfo.operator_id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          curInfo.audit_time || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因">{{
          curInfo.reject_reason || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="失败原因">{{
          curInfo.fail_reason || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{
          curInfo.create_time
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 拒绝 -->
    <el-dialog title="拒绝退押申请" :visible.sync="rejectShow" width="35%">
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请填写拒绝原因"
        v-model="reject_reason"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectShow = false">取 消</el-button>
        <el-button type="primary" @click="reject">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "合作商管理", secondNav: "退押审核" },
      DataList: [],
      Total: 0,
      query: {
        shop_id: "",
        status: "",
        createTime: [],
      },
      Option: [
        { name: "申请单号", value: "id" },
        { name: "店铺", value: "shop_name" },
        { name: "申请人手机号", value: "user_mobile" },
        { name: "退款金额(元)", value: "amount" },
        { name: "申请原因", value: "reason" },
        { name: "状态", value: "status", type: "custom" },
        { name: "申请时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "260px" },
      ],
      curRow: {},
      curInfo: {},
      infoShow: false,
      rejectShow: false,
      reject_reason: "",
      approvingId: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    openInfo(row) {
      this.$axios({
        url: "/user/shopRefundApply/detail",
        params: {
          apply_id: row.id,
        },
      }).then((res) => {
        this.curInfo = res.data.data || {};
        this.infoShow = true;
      });
    },
    approve(row) {
      this.$confirm(
        "同意后将同步执行渠道退款，确定同意该退押申请吗",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.approvingId = row.id;
          this.$axios({
            url: "/user/shopRefundApply/approve",
            data: {
              apply_id: row.id,
              operator_id: this.adminInfo.id,
            },
            method: "post",
          }).then((res) => {
            this.$notify({
              message: "已同意并执行退款",
              duration: 2000,
              type: "success",
            });
            this.approvingId = "";
            this.getList(1);
          }).catch(() => {
            this.approvingId = "";
          });
        })
        .catch(() => {});
    },
    openReject(row) {
      this.curRow = row;
      this.reject_reason = "";
      this.rejectShow = true;
    },
    reject() {
      if (!this.reject_reason) {
        this.$message("请填写拒绝原因");
        return;
      }
      this.$axios({
        url: "/user/shopRefundApply/reject",
        data: {
          apply_id: this.curRow.id,
          operator_id: this.adminInfo.id,
          reject_reason: this.reject_reason,
        },
        method: "post",
      }).then((res) => {
        this.$notify({
          message: "已拒绝",
          duration: 2000,
          type: "success",
        });
        this.rejectShow = false;
        this.getList(1);
      });
    },
    getList(v) {
      let page = v || 1;
      let params = {
        page: page,
        size: 10,
        shop_id: this.query.shop_id || null,
        status: this.query.status,
      };
      if (this.query.createTime !== null && this.query.createTime.length > 0) {
        params.start_time = this.query.createTime[0] + " 00:00:00";
        params.end_time = this.query.createTime[1] + " 23:59:59";
      }
      this.$axios({
        url: "/user/shopRefundApply/page",
        params,
      }).then((res) => {
        this.DataList = res.data.data.rows || [];
        this.Total = res.data.data.total || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
